import designCollection from 'contest/apps/design-details/models/design-collection';
import design from 'contest/apps/design-details/models/design';
import designComment from 'contest/apps/design-details/models/design-comment';
import designCommentCollection from 'contest/apps/design-details/models/design-comment-collection';
import DesignCanvasOverlay from 'contest/apps/design-details/components/design-canvas-overlay';

export default {
    models: {
        designCollection,
        designComment,
        designCommentCollection,
        design,
    },
    components: {
        DesignCanvasOverlay,
    },
};



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/di.js